(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flow-bros-shop-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('flow-shop-panel')) {
    customElements.define('flow-shop-panel', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const menu = this.closest('header-menu');
        const header = this.closest('header-component');
        const submenu = this.closest('.menu-list__submenu');
        const item = submenu?.parentElement;
        const trigger = item?.querySelector('[ref="menuitem"]');
        if (!menu || !header || !submenu || !trigger) return;
        this.abort = new AbortController();
        const listen = (target, name, handler) => target.addEventListener(name, handler, {signal:this.abort.signal});
        const desktop = () => matchMedia('(min-width:750px)').matches;
        let opened = false;
        let closeTimer, finishTimer;
        const duration = () => matchMedia('(prefers-reduced-motion:reduce)').matches ? 0 : 700;
        const measure = () => submenu.style.setProperty('--flow-panel-height', `${this.offsetHeight}px`);
        const open = () => {
          if (!desktop()) return;
          clearTimeout(closeTimer);
          clearTimeout(finishTimer);
          measure();
          opened = true;
          header.dataset.flowActive = 'true';
          submenu.inert = false;
          submenu.dataset.active = '';
          submenu.dataset.flowOpen = 'true';
          trigger.setAttribute('aria-expanded','true');
          menu.setAttribute('aria-expanded','true');
        };
        const close = () => {
          clearTimeout(closeTimer);
          if (!opened) return;
          opened = false;
          if (this.contains(document.activeElement)) document.activeElement.blur();
          submenu.inert = true;
          submenu.dataset.flowOpen = 'false';
          // Keep the header's solid background until the slide has finished.
          finishTimer = setTimeout(() => {
            trigger.setAttribute('aria-expanded','false');
            menu.setAttribute('aria-expanded','false');
            delete submenu.dataset.active;
            delete header.dataset.flowActive;
          }, duration());
        };
        const scheduleClose = () => { clearTimeout(closeTimer); closeTimer = setTimeout(close,100); };
        submenu.inert = true;
        listen(trigger,'pointerenter',event => {if(event.pointerType === 'mouse') open();});
        listen(trigger,'focus',open);
        listen(trigger,'keydown',event => {
          if(event.key === 'ArrowDown' || event.key === ' ') {
            event.preventDefault();open();this.querySelector('[role="tab"][aria-selected="true"]')?.focus();
          }
        });
        listen(submenu,'pointerenter',() => clearTimeout(closeTimer));
        listen(header,'pointerleave',event => {if(event.pointerType === 'mouse') scheduleClose();});
        listen(header,'focusout',event => {if(!header.contains(event.relatedTarget)) close();});
        listen(header,'keydown',event => {
          if(event.key === 'Escape' && opened) {event.preventDefault();trigger.focus();close();}
        });
        // One boundary check covers the full panel, including the blank space beside cards.
        listen(document,'pointermove',event => {
          if(!opened || event.pointerType !== 'mouse') return;
          const bounds = submenu.getBoundingClientRect();
          const head = header.getBoundingClientRect();
          if(event.clientY > bounds.top + this.offsetHeight || event.clientY < head.top || event.clientX < bounds.left || event.clientX > bounds.right) {
            if(!closeTimer) closeTimer = setTimeout(() => {closeTimer=null;close();},100);
          } else {clearTimeout(closeTimer);closeTimer=null;}
        });
        header.querySelectorAll('a,button').forEach(link => {
          if(link === trigger || submenu.contains(link)) return;
          listen(link,'pointerenter',event => {if(event.pointerType === 'mouse') scheduleClose();});
          listen(link,'focus',close);
        });
        this.resizeObserver = new ResizeObserver(measure);
        this.resizeObserver.observe(this);
        this.cleanup = () => {clearTimeout(closeTimer);clearTimeout(finishTimer);};
        const tabs = [...this.querySelectorAll('[role="tab"]')];
        const select = tab => {
          if(tab.getAttribute('aria-selected') === 'true') return;
          tabs.forEach(item => {
            const selected = item === tab;
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
          });
          this.querySelectorAll('[role="tabpanel"]').forEach(panel => {
            panel.hidden = panel.dataset.panelContent !== tab.dataset.panel;
          });
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => select(tab));
          let hoverTimer;
          tab.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') hoverTimer=setTimeout(() => select(tab),100); });
          tab.addEventListener('pointerleave', () => clearTimeout(hoverTimer));
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') next = tabs[(index + 1) % tabs.length];
            if (event.key === 'Home') next = tabs[0];
            if (event.key === 'End') next = tabs[tabs.length - 1];
            if (!next) return;
            event.preventDefault();
            select(next);
            next.focus();
          });
        });
      }
      disconnectedCallback() {
        this.abort?.abort();this.resizeObserver?.disconnect();this.cleanup?.();this.ready=false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
